import { createContext } from 'react';
import { RootStore } from '../../models';

export const StoreContext = createContext<RootStore>({} as RootStore);
